module.exports = __webpack_public_path__ + "img/graveyard_small.f476bbd4.png";